import routerBase from "@nextories/vue-tasks/src/router";
import { createRouter, createWebHistory } from "vue-router";

const AppRoutes = {
  Dashboard: () => import('@/views/Dashboard.vue'),
  Project: () => import('@/views/Project.vue'),
  Home: () => import('@/views/Home.vue'),
  History: () => import('@nextories/vue-tasks/src/views/NxtTasksViewHistory.vue'),
  Login: () => import('@nextories/vue-tasks/src/views/NxtTasksViewLogin.vue'),
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/login",
      name: "login",
      component: AppRoutes.Login,
      meta: {
        layout: "nxt-tasks-login-layout",
      },
      beforeEnter: routerBase.isNotLogged,
    },
    {
      path: "/",
      name: "dashboard",
      component: AppRoutes.Dashboard,
      meta: {
        layout: "nxt-tasks-full-layout",
        checkRefreshCounters: true,
        hasTable: false,
        authRequired: true,
      },
      beforeEnter: routerBase.isLogged,
    },
    {
      path: "/tasks",
      name: "home",
      component: AppRoutes.Home,
      meta: {
        layout: "nxt-tasks-full-layout",
        authRequired: true,
        displayExpandLeftSidebar: true,
        checkRefreshCounters: true,
      },
      beforeEnter: routerBase.isLogged,
    },
    {
      path: "/projects/:id",
      name: "project",
      meta: {
        layout: "nxt-tasks-full-layout",
        authRequired: true,
        hideSidebar: true,
        displayExpandRightSidebar: true,
      },
      beforeEnter: routerBase.isLogged,
      component: AppRoutes.Project,
    },
    {
      path: "/history",
      name: "history",
      component: AppRoutes.History,
      meta: {
        layout: "nxt-tasks-full-layout",
        hasTable: false,
        authRequired: true,
        hideSidebar: true,
      },
      beforeEnter: routerBase.isLogged,
    },
  ],
});

export default router;
